// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
// Copyright (C) 2024 TU Wien.
//
// InvenioRDM TUW is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import { TimelineFeedHeader } from "../requests/timeline/overrides/TimelineFeedHeader";
import { curationComponentOverrides } from "@js/invenio_curations/requests";
import { DepositBox } from "@js/invenio_curations/deposit/DepositBox";
import { RequestMetadata } from "@js/invenio_theme_tuw/RequestMetadata";
import { TUppyUploader } from "@js/invenio_theme_tuw/UploaderField";
import { PublishModalComponent } from "@js/invenio_theme_tuw/PublishModal";

// skip the component override that hides system comments on requests from users
delete curationComponentOverrides["TimelineFeed.layout"];

export const overriddenComponents = {
  ...curationComponentOverrides,
  "InvenioRequest.RequestMetadata.Layout": RequestMetadata,
  "InvenioAppRdm.Deposit.CardDepositStatusBox.container": DepositBox,

  // Guest Access Request customisation
  "TimelineFeed.header": TimelineFeedHeader,

  // hide "copyrights" & "references" fields from upload form
  // the latter is a worse version of related works, since it's not exported to DataCite
  "InvenioAppRdm.Deposit.CopyrightsField.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldReferences.container": () => null,

  // hide folder selection from uppy uploader
  "InvenioAppRdm.Deposit.FileUploader.container": TUppyUploader,

  // add privacy note and required checkbox to the publish modal
  "InvenioRdmRecords.PublishModal.container": PublishModalComponent,
};
